var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdaptabilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 19,
    height: 6.9227,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 21 14.0772)",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22 18.047C4.22 18.9524 4.95416 19.6866 5.86 19.6866C6.76584 19.6866 7.5 18.9524 7.5 18.047C7.5 17.1415 6.76584 16.4074 5.86 16.4074C4.95416 16.4074 4.22 17.1415 4.22 18.047Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2L4.00005 14.5604H8.00005L12.5 5.86473C13.7 3.54589 11.3334 2.32206 10 2Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 11.1787V14.5604H19.6826V11.1787H19.8937C20.5949 11.1787 21.0783 10.4759 20.8276 9.82116L19.6826 6.83092H17.5001L16.3043 9.80579C16.0402 10.4629 16.524 11.1787 17.2322 11.1787H17.5001Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptabilityIcon);
export default __webpack_public_path__ + "static/media/adaptability_icon.bc437bca782f9fd5e4cb9c80c345dd21.svg";
export { ForwardRef as ReactComponent };